import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import { useState } from "react";
import { getCurrentEnviornment } from "utils/constants";

function UseGetCurrentUser() {
  const [userId, setUsreId] = useState(
    localStorage.getItem(`${getCurrentEnviornment()}_userId`)
  );
  const [getUser, { data, isLoading, error }]: any = UseLazyApiCallV2({
    url: "/get_user_detail",
    method: "POST",
    paramsData: { email: userId },
  });

  async function refetchUserV1() {
    const userId = localStorage.getItem(`${getCurrentEnviornment()}_userId`);
    if (!userId) return;
    return await getUser({ params: { email: userId } });
  }

  return { data: data?.userDetail, isLoading, error, refetch: refetchUserV1 };
}

export { UseGetCurrentUser };
